import commitMutation from 'relay-commit-mutation-promise';
import { graphql, Environment } from 'react-relay';
import { RecordSourceSelectorProxy } from 'relay-runtime';

import {
    deleteDesignProjectMutation,
    DeleteDesignProjectMutationInput,
    deleteDesignProjectMutationResponse,
} from './__generated__/deleteDesignProjectMutation.graphql';

type DeleteDesignProjectMutationArgs = DeleteDesignProjectMutationInput & {
    urlLabel: string;
};

const mutation = graphql`
    mutation deleteDesignProjectMutation($input: DeleteDesignProjectMutationInput!) {
        deleteDesignProjectMutation(input: $input) {
            projectId
        }
    }
`;

// delete project from relay store
const updater = (store: RecordSourceSelectorProxy, args: DeleteDesignProjectMutationArgs): void => {
    const payload = store.getRootField('deleteDesignProjectMutation');
    const deletedProjectId = payload && payload.getValue('projectId');

    const designProjectsArgs = {
        visibility: ['Y', 'N'],
        status: ['ACTIVE', 'PENDING'],
    };

    const viewer = store.getRoot().getLinkedRecord('viewer');
    if (viewer) {
        const tradeFirms = viewer.getLinkedRecords('tradeFirms', { urlLabel: args.urlLabel }) || [];
        const publicProfile = !!tradeFirms.length && tradeFirms[0].getLinkedRecord('publicProfile');

        if (publicProfile) {
            const designProjects =
                publicProfile.getLinkedRecords('designProjects', designProjectsArgs) || [];
            const updatedProjects = designProjects.filter(
                project => project.getValue('serviceId') !== deletedProjectId
            );
            publicProfile.setLinkedRecords(updatedProjects, 'designProjects', designProjectsArgs);
        }
    }
};

export const deleteDesignProject = async (
    environment: Environment,
    args: DeleteDesignProjectMutationArgs
): Promise<deleteDesignProjectMutationResponse> => {
    return await commitMutation<deleteDesignProjectMutation>(environment, {
        updater: store => updater(store, args),
        mutation,
        variables: {
            input: {
                projectId: args.projectId,
            },
        },
    });
};
